(function () {
    var closeSvgMarkup = '<svg data-wss-close-icon="true" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M1.00032 0.999928L13.3747 13.3743M1.00032 13.3743L13.3747 0.999928" stroke="#333333" stroke-width="2" stroke-linecap="round"/></svg>';

    function applyCloseSvgStyles(svg) {
        svg.style.setProperty('width', '15px', 'important');
        svg.style.setProperty('height', '15px', 'important');
        svg.style.setProperty('top', '20px', 'important');
        svg.style.setProperty('right', '22px', 'important');
    }

    function replaceCloseSvg(wrapper) {
        var svg = wrapper.querySelector('svg');
        var image = wrapper.querySelector('img');

        if (svg) {
            if (svg.getAttribute('data-wss-close-icon') === 'true') {
                applyCloseSvgStyles(svg);
                return;
            }

            svg.setAttribute('data-wss-close-icon', 'true');
            svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
            svg.setAttribute('width', '15');
            svg.setAttribute('height', '15');
            svg.setAttribute('viewBox', '0 0 15 15');
            svg.setAttribute('fill', 'none');
            svg.innerHTML = '<path d="M1.00032 0.999928L13.3747 13.3743M1.00032 13.3743L13.3747 0.999928" stroke="#333333" stroke-width="2" stroke-linecap="round"/>';
            applyCloseSvgStyles(svg);
            return;
        }

        if (image) {
            image.insertAdjacentHTML('afterend', closeSvgMarkup);
            applyCloseSvgStyles(image.nextElementSibling);
            image.remove();
            return;
        }

        wrapper.insertAdjacentHTML('beforeend', closeSvgMarkup);
        applyCloseSvgStyles(wrapper.lastElementChild);
    }

    function replaceRestockCloseSvgs() {
        document.querySelectorAll('.restock-alerts-modal-box .modalCloseButtonWrapper').forEach(replaceCloseSvg);
    }

    replaceRestockCloseSvgs();
    document.addEventListener('DOMContentLoaded', replaceRestockCloseSvgs);

    new MutationObserver(replaceRestockCloseSvgs).observe(document.documentElement, {
        childList: true,
        subtree: true
    });
})();
